export default __webpack_public_path__ + "static/media/123.a612b8ec.png";